import { z } from 'zod';
import { Country } from '@trnsact/trnsact-shared-types';

const trimmedStr = z.string().trim();
const trimmedReqStr = z.string().trim().min(1, { message: 'Required field' });

const selectOptionSchema = z.object({
  label: z.string(),
  value: z.string(),
});

export const salesCenterFormSchema = z.object({
  name: trimmedReqStr,
  description: trimmedStr,

  equipment: z.object({
    type: selectOptionSchema.array(),
  }),

  customer: z
    .object({
      type: selectOptionSchema.array(),
      paymentType: selectOptionSchema.array(),
    })
    .partial(),

  address: z.object({
    country: z.nativeEnum(Country),
    zip: z.array(trimmedStr).optional(),
    city: z.array(trimmedStr).optional(),
    county: z.array(trimmedStr).optional(),
    postalCode: z.array(trimmedStr).optional(),
    state: z.array(selectOptionSchema).optional(),
    province: z.array(selectOptionSchema).optional(),
  }),

  charges: z.array(
    z.object({
      type: trimmedStr,
      amount: z.number(),
      name: trimmedReqStr,
      isTaxable: z.boolean(),
      description: trimmedStr,
      amountType: trimmedReqStr,
      isEquipmentLvl: z.boolean(),
    })
  ),

  taxes: z.array(
    z.object({
      type: trimmedStr,
      amount: z.number(),
      name: trimmedReqStr,
      isTaxable: z.boolean(),
      amountType: trimmedReqStr,
      description: trimmedStr,
      isEquipmentLvl: z.boolean(),
    })
  ),
});

export type DealSheetFormValues = z.infer<typeof salesCenterFormSchema>;
